<template>
  <div class="function-list">
    <p class="tip-block">
      <Icon type="md-alert" />
      {{ $t('services.funcTip') }}
    </p>
    <Table :columns="recordsCol" :data="tableData"></Table>
  </div>
</template>

<script lang="jsx">
import { loadServicesFuncs } from '@/api/services'
import nodeID from '@/mixins/nodeID'

export default {
  name: 'FunctionList',

  mixins: [nodeID],

  data() {
    return {
      tableData: [],
      recordsCol: [
        {
          title: this.$t('services.funcName'),
          key: 'name',
        },
      ],
    }
  },

  created() {
    this.loadData()
  },

  methods: {
    loadData() {
      loadServicesFuncs(this.nodeID, this.serviceName).then((res) => {
        this.tableData = res.data.map((func) => ({ name: func }))
      })
    },
  },
}
</script>

<style lang="scss">
.function-list {
  h3 {
    margin-bottom: 24px;
  }
  .tip-block {
    margin-bottom: 20px;
  }
}
</style>
